import { render, staticRenderFns } from "./monitorAnxun.vue?vue&type=template&id=072f44df&scoped=true"
import script from "./monitorAnxun.vue?vue&type=script&lang=js"
export * from "./monitorAnxun.vue?vue&type=script&lang=js"
import style0 from "./monitorAnxun.vue?vue&type=style&index=0&id=072f44df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072f44df",
  null
  
)

export default component.exports